import { tokensInfo } from './wallets';

export const MAGIC_SWAP_DEFAULT_NETWORK_ID = 56;

export const MAGIC_SWAP_DEFAULT_TOKEN_TO_SELL = 'USDT';

export const MAGIC_SWAP_DEFAULT_TOKEN_ADDRESS_TO_RECEIVE =
  tokensInfo.SQR.contractsAddresses.token.toLowerCase();

export const ONE_INCH_NATIVE_NETWORK_TOKEN_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
